"use client";

import React, { useEffect, useState } from "react";
import i18n from "@/locales/i18n";
import { I18nextProvider } from "react-i18next";
import { SplashScreen } from "@/components/minimal-components/loading-screen";

export default function TranslationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      if (!i18n.isInitialized) {
        await i18n.init(); // 👈 preload resources manually
      }
      setReady(true);
    };
    init();
  }, []);

  if (!ready) return <SplashScreen />;

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
